// Lleva un elemento a la vista y le da foco. Se usa tras un submit fallido para
// que el usuario no quede mirando un boton que "no hace nada": en mobile el
// campo que freno el submit suele quedar fuera de pantalla. preventScroll en
// focus() para no cancelar el scroll suave que disparamos antes.
export function scrollToField(el: HTMLElement | null): void {
  if (!el) return;
  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  el.focus({ preventScroll: true });
}

// Encuadra un GRUPO de campos relacionados (ej: los dos emails, o password + su
// checklist) y le da foco al campo objetivo. Pensado para pantallas de alto
// limitado: al corregir el email querés ver el campo y su confirmación juntos, no
// centrar uno solo dejando el otro fuera de vista. `focusEl` recibe el foco (con
// preventScroll, para no cancelar el scroll suave del grupo); si no se pasa, se
// enfoca el primer control del grupo.
export function scrollToGroup(group: HTMLElement | null, focusEl?: HTMLElement | null): void {
  if (!group) return;
  group.scrollIntoView({ behavior: 'smooth', block: 'center' });
  const target =
    focusEl ?? group.querySelector<HTMLElement>('input, select, textarea, button');
  target?.focus({ preventScroll: true });
}
